import React from 'react'
import lodash from 'lodash'
import { initialState, userReducer } from './UserReducer'

const UserContext = React.createContext()

const UserContextProvider = (props) => {
  const [state, dispatch] = React.useReducer(userReducer, initialState)
  const value = React.useMemo(() => [state, dispatch], [state])

  return <UserContext.Provider value={value} {...props} />
}

const useUserContext = () => {
  const context = React.useContext(UserContext)

  if (!context) {
    throw new Error('useUserContext must be used within a UserContextProvider')
  }

  const [state, dispatch] = context

  const setUserName = (userName) => {
    dispatch({ type: 'SET_USERNAME', userName })
  }

  const setUserDetails = (userDetails) => {
    dispatch({ type: 'SET_USERDETAILS', userDetails })
  }

  const setPermissions = (permissions) => {
    dispatch({ type: 'SET_PERMISSIONS', permissions })
  }

  const setAssignedClients = (assignedClients) => {
    dispatch({ type: 'SET_ASSIGNEDCLIENTS', assignedClients })
  }

  const setAssignedClientsLegacy = (assignedClientsLegacy) => {
    dispatch({ type: 'SET_ASSIGNEDCLIENTSLEGACY', assignedClientsLegacy })
  }

  const setAssignedSubUnits = (assignedSubUnits) => {
    dispatch({ type: 'SET_ASSIGNEDSUBUNITS', assignedSubUnits })
  }

  const setAssignedProfitCenter = (assignedProfitCenter) => {
    dispatch({ type: 'SET_ASSIGNEDPROFITCENTER', assignedProfitCenter })
  }

  const setTeams = (teams) => {
    dispatch({ type: 'SET_TEAMS', teams })
  }

  const setRoles = (roles) => {
    dispatch({ type: 'SET_ROLES', roles })
  }

  const setSubordinates = (subordinates) => {
    dispatch({ type: 'SET_SUBORDINATES', subordinates })
  }

  const setShowHelp = (showHelp) => {
    dispatch({ showHelp: showHelp })
  }

  const isManagerDefaultRole = () => {
    let result = false

    const roles = lodash(state.permissions)
      .map((p) => p.role)
      .uniq()
      .value()

    if (roles.length === 1 && roles[0] === 'MANAGER_DEFAULT') {
      result = true
    }

    return result
  }

  return {
    ...state,
    dispatch,
    setUserName,
    setUserDetails,
    setPermissions,
    setAssignedClients,
    setAssignedClientsLegacy,
    setAssignedSubUnits,
    setAssignedProfitCenter,
    setTeams,
    setRoles,
    setSubordinates,
    setShowHelp,
    isManagerDefaultRole,
  }
}

export { UserContext, UserContextProvider, useUserContext }
